/**
 * Login status component (SearchLogin).
 * @param {string} componentId
 * @constructor
 * @extends {Foundation.Component}
 */
Foundation.LoginRequiredComponent = function (componentId) {
    Foundation.Component.call(this, componentId);

    this.loggedInView = this.view.find("[data-view=loggedin]");
    this.loggedOutView = this.view.find("[data-view=loggedout]");

    var manager = Foundation.Session.Manager.sharedInstance();
    this.loggedOutView.find("a[href$='#LogIn']").on('click', this.beginLoginDialog.bind(this, "LogIn"));
    this.loggedOutView.find("a[href$='#CreateAccount']").on('click', this.beginLoginDialog.bind(this, "CreateAccount"));
    this.loggedInView.find("a[href$='/Logout']").on('click', this.logOut.bind(this));

    manager.observe("login", this.updateViews.bind(this));
    manager.observe("logout", this.updateViews.bind(this));

    this.updateViews();
};
Foundation.inherit(Foundation.LoginRequiredComponent, Foundation.Component);

/**
 * Update the login status view with the current login context.
 * @private
 */
Foundation.LoginRequiredComponent.prototype.updateViews = function () {
    const manager = Foundation.Session.Manager.sharedInstance();
    let hideThisView, showThisView

    if (manager.isAuthenticated()) {
        var member = manager.authenticatedMember();
        this.loggedInView.find("[data-label=username]").html(member.get("userName"));
        this.loggedInView.find("img[data-view=avatar]").attr("src", member.get("avatarUrl"));
        hideThisView = this.loggedOutView;
        showThisView = this.loggedInView;
    }
    else {
        hideThisView = this.loggedInView;
        showThisView = this.loggedOutView;
    }

    hideThisView.hide();
    showThisView.show();
}

/**
 * Kick off the login modal dialog box.
 * @param {string} showComponent Start up the dialog box showing this component.
 * @param {jQuery.Event} e
 */
Foundation.LoginRequiredComponent.prototype.beginLoginDialog = function (showComponent, e) {
    e.preventDefault();
    // Hide all panels.
    Foundation.Mobile.Panel.closeAll();
    new Foundation.Login.Dialog({
        "show": showComponent
    });
};

/**
 * Log the user out.
 * @param {jQuery.Event} e
 */
Foundation.LoginRequiredComponent.prototype.logOut = function (e) {
    e.preventDefault();

    // Show a spinner while we wait.
    new Foundation.View.Spinner();

    var sessionManager = Foundation.Session.Manager.sharedInstance();
    sessionManager.logOut().then(function () {
        /*
        No redirect on mobile, at most we will show a confirmation message
        setTimeout(function () {
            window.location.href = "/gyrobase/Logout";
        }, 500);
        */
    });
};

// ---------------------------------------------------------------------

window["Foundation"]["LoginRequiredComponent"] = Foundation.LoginRequiredComponent;

// ---------------------------------------------------------------------
